

import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import Hero from './components/Hero';
import About from './components/About';
import Clients from './components/Clients';
import Portfolio from './components/Portfolio';
import ComingSoon from './components/ComingSoon';
import Footer from './components/Footer';
import Services from './components/Services';

function App() {
  return (
    <div className="gradient-bg min-h-screen">
      <ParallaxProvider>
        <Hero />
        <About />
        <Services />
        <Clients />
        <Portfolio />
        <ComingSoon />
        <Footer />
      </ParallaxProvider>
    </div>
  );
}

export default App;

//2

// import React from 'react';
// import { ParallaxProvider } from 'react-scroll-parallax';
// import Hero from './components/Hero';
// import About from './components/About';
// import Clients from './components/Clients';
// import Portfolio from './components/Portfolio';
// import ComingSoon from './components/ComingSoon';
// import Footer from './components/Footer';
// import Services from './components/Services';
// import './ScrollSnap.css';

// function App() {
//   return (
//     <ParallaxProvider>
//       <div className="gradient-bg">
//         <section className="scroll-snap-section">
//           <Hero />
//         </section>

//         <section className="scroll-snap-section">
//           <About />
//         </section>

//         <section className="scroll-snap-section">
//           <Services />
//         </section>

//         <section className="scroll-snap-section">
//           <Clients />
//         </section>

//         <section className="scroll-snap-section">
//           <Portfolio />
//         </section>

//         <section className="scroll-snap-section">
//           <ComingSoon />
//         </section>

//         <section className="scroll-snap-section">
//           <Footer />
//         </section>
//       </div>
//     </ParallaxProvider>
//   );
// }

// export default App;